import { useMemo, useState } from 'react';
import FeedEditor from './FeedEditor'
import DashboardScreen from './DashboardScreen'
import Notification from '../Global/Notification';
import ConfirmDialog from '../Global/ConfirmDialog';
import SettingsPage from './SettingsPage';
import AboutPage from './AboutPage';
import SupportPage from './SupportPage';
import UpsellPopupModal from '../Modals/UpsellPopupModal';
import SbUtils from '../../Utils/SbUtils';

const HomeScreen = () => {
    const sbCustomizer = window.sb_customizer;
    const [ loader, setLoader ] = useState( false );
    const [ isPro, setIsPro ] = useState( sbCustomizer?.isPro && sbCustomizer?.isPro ? true : false  );

    const editorTopLoader = useMemo(
        () => ({ loader, setLoader }),
		[ loader, setLoader ]
    );

    const [ notification, setNotification ] = useState({
        active : false
    });
    const editorNotification = useMemo(
        () => ({ notification, setNotification }),
		[ notification, setNotification ]
    );


    const [ confirmDialog, setConfirmDialog ] = useState({
        active : false
    });

    const editorConfirmDialog = useMemo(
        () => ({ confirmDialog, setConfirmDialog }),
		[ confirmDialog, setConfirmDialog ]
    );

    const [ addApiKeyModal, setAddApiKeyModal ] = useState( {
        active : false
    } );
    const apiKeyModal = useMemo(
        () => ({ addApiKeyModal, setAddApiKeyModal}),
		[addApiKeyModal, setAddApiKeyModal]
    );

    const [ tiers, setTiers ] = useState( sbCustomizer?.pluginStatus?.tier_allowed_providers ?? [ 'google', 'yelp' ]);
    const allowedTiers = useMemo(
        () => ({ tiers, setTiers }),
		[tiers, setTiers]
    );

    //Check for Facebook Sources Modal
    const [ connectFacebookActive , setConnectFacebookActive ] = useState( sbCustomizer?.newSourceData !== undefined );
    const fbModal = useMemo(
        () => ({ connectFacebookActive , setConnectFacebookActive }),
		[ connectFacebookActive , setConnectFacebookActive ]
    );


    //Check for Manual Facebook Sources Modal
    const [ connectFacebookManualActive , setConnectFacebookManualActive ] = useState( sbCustomizer?.manualSourcePopupInit !== undefined );
    const fbManualModal = useMemo(
        () => ({ connectFacebookManualActive , setConnectFacebookManualActive }),
		[ connectFacebookManualActive , setConnectFacebookManualActive ]
    );




    const [ pluginSettings , setPluginSettings ] = useState( sbCustomizer?.pluginSettings );

    const globalSettings = useMemo(
        () => ({ pluginSettings , setPluginSettings }),
		[ pluginSettings , setPluginSettings ]
    );


    const [ upsellActive , setUpsellActive ] = useState( false );
    const upsellModal = useMemo(
        () => ({ upsellActive , setUpsellActive }),
		[ upsellActive , setUpsellActive  ]
    );

    const [ feedData, setFeedData ] = useState( sbCustomizer?.feedData || []  );
    const editorFeedData = useMemo(
        () => ({ feedData, setFeedData }),
		[feedData, setFeedData]
    );

   const [ apiKeys, setApiKeys ] = useState( sbCustomizer.apiKeys || [] );
    const apis = useMemo(
        () => ({ apiKeys, setApiKeys }),
		[apiKeys, setApiKeys]
    );

    const [ apiKeyLimits, setApiKeyLimits  ] = useState( sbCustomizer.apiKeyLimits || [] );
    const apiLimits = useMemo(
        () => ({ apiKeyLimits, setApiKeyLimits }),
		[apiKeyLimits, setApiKeyLimits]
    );



    const [ topNoticeBar, setTopNoticeBar ] = useState({});
    const noticeBar = useMemo(
        () => ({ topNoticeBar, setTopNoticeBar  }),
		[ topNoticeBar, setTopNoticeBar ]
    );

    const noticeBarMemo = useMemo(
        () => SbUtils.checkAPIKeys( noticeBar, topNoticeBar, apis, feedData, apiKeyModal, apiLimits, isPro ),
        [ noticeBar, topNoticeBar, apis, feedData, apiKeyModal ]
    );

    //const [ topNoticeBarActive, setTopNoticeBarActive ] = useState(false);
    const topNoticeBarActive = useMemo( () => {
        let isActive = false
        if( noticeBarMemo !== undefined ){
            Object.keys(noticeBarMemo.topNoticeBar)?.forEach( ( nbr, nbKey ) => {
               nbr = noticeBarMemo.topNoticeBar[nbr];
               if( nbr.active === true )
                   isActive = true;
            });
        }

        return isActive;
    },[topNoticeBar, apiKeys]);


    return (
        <>
            { //DashBoard Screen
                (!sbCustomizer.isFeedEditor && sbCustomizer.reactScreen === 'customizer') &&
                <DashboardScreen
                    editorTopLoader={ editorTopLoader }
                    editorNotification={ editorNotification }
                    editorConfirmDialog={ editorConfirmDialog }
                    apiKeyModal={ apiKeyModal }
                    fbModal={ fbModal }
                    globalSettings={ globalSettings }
                    allowedTiers={ allowedTiers }
                    isPro={ isPro }
                    upsellModal={ upsellModal }

                    editorFeedData={editorFeedData}
                    apis={apis}
                    apiLimits={apiLimits}
                    noticeBar={noticeBar}
                    noticeBarMemo={noticeBarMemo}
                    topNoticeBarActive={topNoticeBarActive}
                    fbManualModal={fbManualModal}
                />
            }

            { //Feed Editor
               ( sbCustomizer.isFeedEditor && sbCustomizer.reactScreen === 'customizer')  &&
                <FeedEditor
                    editorTopLoader={ editorTopLoader }
                    editorNotification={ editorNotification }
                    editorConfirmDialog={ editorConfirmDialog }
                    apiKeyModal={ apiKeyModal }
                    fbModal={ fbModal }
                    allowedTiers={ allowedTiers }
                    isPro={ isPro }
                    upsellModal={ upsellModal }

                    editorFeedData={editorFeedData}
                    apis={apis}
                    apiLimits={apiLimits}
                    noticeBar={noticeBar}
                    noticeBarMemo={noticeBarMemo}
                    topNoticeBarActive={topNoticeBarActive}
                    fbManualModal={fbManualModal}
                />
            }

            { //Settings Page
               sbCustomizer.reactScreen === 'settings' &&
                <SettingsPage
                    editorTopLoader={ editorTopLoader }
                    editorNotification={ editorNotification }
                    editorConfirmDialog={ editorConfirmDialog }
                    apiKeyModal={ apiKeyModal }
                    fbModal={ fbModal }
                    allowedTiers={ allowedTiers }
                    isPro={ isPro }
                    upsellModal={ upsellModal }

                    editorFeedData={editorFeedData}
                    apis={apis}
                    apiLimits={apiLimits}
                    noticeBar={noticeBar}
                    noticeBarMemo={noticeBarMemo}
                    topNoticeBarActive={topNoticeBarActive}
                    fbManualModal={fbManualModal}
                />
            }

            { //About Us Page
               sbCustomizer.reactScreen === 'aboutus' &&
                <AboutPage
                    sbCustomizer={ sbCustomizer }
                    editorTopLoader={ editorTopLoader }
                    editorNotification={ editorNotification }
                    editorConfirmDialog={ editorConfirmDialog }
                    isPro={ isPro }
                    upsellModal={ upsellModal }

                    editorFeedData={editorFeedData}
                    apis={apis}
                    apiLimits={apiLimits}
                    noticeBar={noticeBar}
                    noticeBarMemo={noticeBarMemo}
                    topNoticeBarActive={topNoticeBarActive}
                />
            }

            { //Support Page
               sbCustomizer.reactScreen === 'support' &&
                <SupportPage
                    sbCustomizer={ sbCustomizer }
                    editorTopLoader={ editorTopLoader }
                    editorNotification={ editorNotification }
                    editorConfirmDialog={ editorConfirmDialog }
                    isPro={ isPro }
                    upsellModal={ upsellModal }

                    editorFeedData={editorFeedData}
                    apis={apis}
                    apiLimits={apiLimits}
                    noticeBar={noticeBar}
                    noticeBarMemo={noticeBarMemo}
                    topNoticeBarActive={topNoticeBarActive}
                />
            }

            <Notification
                active={ editorNotification.notification?.active }
                icon={ editorNotification.notification?.icon }
                text={ editorNotification.notification?.text }
                type={ editorNotification.notification?.type }
            />
            <ConfirmDialog
                active={ editorConfirmDialog.confirmDialog?.active }
                heading={ editorConfirmDialog.confirmDialog?.heading }
                description={ editorConfirmDialog.confirmDialog?.description }
                confirm={ editorConfirmDialog.confirmDialog?.confirm }
                cancel= { editorConfirmDialog.confirmDialog?.cancel }
                onClose = { () => {
                    editorConfirmDialog.setConfirmDialog({
                        active : false
                    });
                } }
            />

            <UpsellPopupModal
                upsellModal={upsellModal}
                upsellContent={sbCustomizer?.upsellContent}
            />
        </>
    )
}

export default HomeScreen;